// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-rfp-title {
  height: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 800px;
}
.view-rfp-modal {
  width: 841px;
  height: 767px;
}
.request-proposal-txt {
  font-size: 19px;
  font-weight: 700;
  font-family: Montserrat;
}
.external-searc-btn {
  height: 40px;
  width: 215px;
  background-color: #f0f0f0;
  border: none;
}
.view-download-btn {
  height: 40px;
  width: 168px;
  background-color: #d2042d;
  border: none;
}
.external-searc-btn-txt {
  font-size: 16px;
  font-weight: 500;
}
.view-download-btn-txt {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}
.view-download-btn:hover {
  height: 40px;
  width: 168px;
  background-color: #d2042d !important;
}
.external-searc-btn:hover {
  height: 40px;
  width: 215px;
  background-color: #f0f0f0 !important;
}
.view-rfp-logo {
  width: 11.19238rem;
  height: 2.9375rem;
}
.view-rfp-cont {
  padding-inline: 20px;
}
.color-bar {
  background-color: #d2042d;
  height: 20px;
}
.external-search-request {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.request-details {
  font-size: 14px;
  font-weight: 400;

  color: #5b5e5d;
}
.view-table-header {
  background-color: #e0e0e0;
  height: 45px;
  align-items: center;
}
.table-heading-txt {
  color: #0a0f0d;
  display: flex;
  padding-left: 0.5rem;
  font-size: 14px;
  font-weight: 500;
}
.table-content-txt {
  color: #5b5e5d;
  padding-left: 0.5rem;

  align-items: center;
  font-size: 14px;
  font-weight: 400;
}
.view-table-container {
  height: 45px;
  align-items: center;
  border-bottom: #cecece solid 1px;
}
.support-txt-view {
  font-size: 14px;
  font-weight: 400;
}
.view-rfp-footer {
  height: 75px;
  background-color: #d2042d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.view-greet-msg {
  font-size: 24px;
  color: #fff;
  font-weight: 700;
  font-family: Montserrat;
}
.close-model-icon {
  border-radius: 0.3125rem;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 2.75rem;
  height: 2.5rem;
}

.view-rfp-button-col {
  gap: 1rem;
  display: flex;
}

.view-rfp-cont-row {
  margin-top: 1rem;
  justify-content: space-between;
  flex-flow: nowrap;
}
.rfp-view-label{
  color:#d2042d ;
}
@media(max-width:430px){
.view-table-container{
  width: max-content;
  overflow-x: auto;
}

.table-heading-txt{
  font-size: 9px !important;
}
}`, "",{"version":3,"sources":["webpack://./src/components/modal/view-rfp-modal/ViewRFP.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;;EAEhB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;;EAEpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA","sourcesContent":[".view-rfp-title {\n  height: 90px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 800px;\n}\n.view-rfp-modal {\n  width: 841px;\n  height: 767px;\n}\n.request-proposal-txt {\n  font-size: 19px;\n  font-weight: 700;\n  font-family: Montserrat;\n}\n.external-searc-btn {\n  height: 40px;\n  width: 215px;\n  background-color: #f0f0f0;\n  border: none;\n}\n.view-download-btn {\n  height: 40px;\n  width: 168px;\n  background-color: #d2042d;\n  border: none;\n}\n.external-searc-btn-txt {\n  font-size: 16px;\n  font-weight: 500;\n}\n.view-download-btn-txt {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n.view-download-btn:hover {\n  height: 40px;\n  width: 168px;\n  background-color: #d2042d !important;\n}\n.external-searc-btn:hover {\n  height: 40px;\n  width: 215px;\n  background-color: #f0f0f0 !important;\n}\n.view-rfp-logo {\n  width: 11.19238rem;\n  height: 2.9375rem;\n}\n.view-rfp-cont {\n  padding-inline: 20px;\n}\n.color-bar {\n  background-color: #d2042d;\n  height: 20px;\n}\n.external-search-request {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000000;\n}\n.request-details {\n  font-size: 14px;\n  font-weight: 400;\n\n  color: #5b5e5d;\n}\n.view-table-header {\n  background-color: #e0e0e0;\n  height: 45px;\n  align-items: center;\n}\n.table-heading-txt {\n  color: #0a0f0d;\n  display: flex;\n  padding-left: 0.5rem;\n  font-size: 14px;\n  font-weight: 500;\n}\n.table-content-txt {\n  color: #5b5e5d;\n  padding-left: 0.5rem;\n\n  align-items: center;\n  font-size: 14px;\n  font-weight: 400;\n}\n.view-table-container {\n  height: 45px;\n  align-items: center;\n  border-bottom: #cecece solid 1px;\n}\n.support-txt-view {\n  font-size: 14px;\n  font-weight: 400;\n}\n.view-rfp-footer {\n  height: 75px;\n  background-color: #d2042d;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.view-greet-msg {\n  font-size: 24px;\n  color: #fff;\n  font-weight: 700;\n  font-family: Montserrat;\n}\n.close-model-icon {\n  border-radius: 0.3125rem;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 2.75rem;\n  height: 2.5rem;\n}\n\n.view-rfp-button-col {\n  gap: 1rem;\n  display: flex;\n}\n\n.view-rfp-cont-row {\n  margin-top: 1rem;\n  justify-content: space-between;\n  flex-flow: nowrap;\n}\n.rfp-view-label{\n  color:#d2042d ;\n}\n@media(max-width:430px){\n.view-table-container{\n  width: max-content;\n  overflow-x: auto;\n}\n\n.table-heading-txt{\n  font-size: 9px !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
